import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/victoria")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Victoria, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades, marine canvas and aluminum fabrication for Victoria & Victoria County.",
      keywords: "pergola covers Victoria, pergola covers Texas, custom pergola covers Victoria, aluminum pergola covers Victoria",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Victoria, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Victoria and Victoria County.",
    }),
    scripts: cityHeadScripts("Victoria", "Victoria County"),
  }),
  component: () => <CityHomePage city="Victoria" region="Victoria County" />,
});
